import type { unitOfTime } from 'moment'
import type { MomentExtended } from './types'

const MONTH_YEAR_FORMAT = '%m/%Y'

/**
 * Date formatter for period dates
 *
 * WARNING: This is a JS transpilation of the code in Ledger.period_name (/app/models/ledger.rb)
 * if you modify any behavior here, please also modify the ruby code accordingly
 *
 * @date { moment-strftime Date } a strftime-able moment date object
 * @ledgersPerYear { Number } One of 1, 4 or 12 - number of ledgers per year
 * @format { String } strftime supported format. Optional, takes precedence on ledgersPerYear
 */
export function periodName({
  date,
  ledgersPerYear,
  format,
}: {
  date: MomentExtended
  ledgersPerYear: number
  format?: string
}): string | undefined {
  if (format) {
    return date.strftime(format)
  }
  let quarter = null

  switch (ledgersPerYear) {
    case 1:
      return `${date.year()}`
    case 4: // eslint-disable-line no-case-declarations
      switch (
        date.month() + 1 // month() is 0 index, FFS javascript
      ) {
        case 3:
          quarter = 1
          break
        case 6:
          quarter = 2
          break
        case 9:
          quarter = 3
          break
        case 12:
          quarter = 4
          break
      }

      if (quarter) {
        return `Q${quarter} ${date.year()}`
      } else {
        return date.strftime(MONTH_YEAR_FORMAT)
      }
    case 12:
      return date.strftime(MONTH_YEAR_FORMAT)
  }
}

const isCurrent = (
  unit: unitOfTime.StartOf | undefined,
  datetime: MomentExtended
): boolean => datetime.isSame(new Date(), unit)
export const isCurrentYear = (datetime: MomentExtended): boolean =>
  isCurrent('year', datetime)
export const isCurrentDate = (datetime: MomentExtended): boolean =>
  isCurrent('day', datetime)
